"use client"

import Link from "next/link"
import { usePathname, useSearchParams } from "next/navigation"
import { i18n } from "../../../i18n-config"
// import "node_modules/flag-icons/css/flag-icons.min.css"
import { useEffect, useState } from "react"
import FlagIcon from "./flag-icon"
import Menu from "@/base-components/Menu"
import Lucide from "@/base-components/Lucide"
import { US } from "country-flag-icons/react/3x2"
import { FR } from "country-flag-icons/react/3x2"
import { ChevronDown } from "lucide-react"

export default function LocaleSwitcher({ lang }) {
  const pathName = usePathname()
  const searchParams = useSearchParams()

  const redirectedPathName = (locale: string) => {
    if (!pathName) return "/"
    const segments = pathName.split("/")
    segments[1] = locale
    const base = segments.join("/")
    const qs = searchParams.toString()
    return qs ? `${base}?${qs}` : base
  }

  useEffect(() => {
    const setupLanguages = async () => {
      setLanguages(i18n.locales)
    }
    setupLanguages()
  }, [])

  const [isOpen, setIsOpen] = useState(false)
  const [languages, setLanguages] = useState([])
  const LANGUAGE_SELECTOR_ID = "language-selector"
  const selectedLanguage = pathName.split("/")[1]
  return (
    // <div className="flex items-center z-40">
    //   <div className="relative inline-block text-left">
    //     <div>
    //       <button
    //         onClick={() => setIsOpen(!isOpen)}
    //         type="button"
    //         className="inline-flex items-center justify-center w-full rounded-md border border-white/[0.12] hover:text-opacity-75 shadow-sm px-4 py-2 text-sm font-medium text-white  focus:outline-none focus:ring-offset-2 "
    //         id={LANGUAGE_SELECTOR_ID}
    //         aria-haspopup="true"
    //         aria-expanded={isOpen}
    //       >
    //         <FlagIcon countryCode={selectedLanguage} />
    //         {selectedLanguage === "en" ? "English" : "Français"}
    // <svg
    //   className="-mr-1 ml-2 h-5 w-5"
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 20 20"
    //   fill="currentColor"
    //   aria-hidden="true"
    // >
    //   <path
    //     fillRule="evenodd"
    //     d="M10.293 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L10 12.586l3.293-3.293a1 1 0 011.414 1.414l-4 4z"
    //     clipRule="evenodd"
    //   />
    // </svg>
    //       </button>
    //     </div>
    //     {isOpen && (
    //       <div
    //         className="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
    //         role="menu"
    //         aria-orientation="horizontal"
    //         aria-labelledby="language-selector"
    //       >
    //         <div
    //           className="bg-dark rounded-lg z-999 border border-white/[0.12]"
    //           role="none"
    //         >
    //           {languages.map((language, index) => {
    //             return (
    //               <Link
    //                 key={language}
    //                 href={redirectedPathName(language)}
    //                 onClick={() => setIsOpen(false)}
    //                 className={`${
    //                   selectedLanguage === language
    //                     ? "bg-white-100 "
    //                     : "text-gray-700"
    //                 } block px-4 py-2 text-sm text-left items-center text-white text-sm hover:text-opacity-75 inline-flex hover:bg-white-100 ${
    //                   index % 2 === 0 ? "rounded-r" : "rounded-l"
    //                 }`}
    //                 role="menuitem"
    //               >
    //                 <FlagIcon countryCode={language} />
    //                 <span className="truncate">
    //                   {language === "en" ? "English" : "Français"}
    //                 </span>
    //               </Link>
    //             )
    //           })}
    //         </div>
    //       </div>
    //     )}
    //   </div>
    // </div>
    <div className="flex justify-center items-center">
      <Menu>
        <Menu.Button className="flex bg-dark-6  p-2 px-3 overflow-hidden rounded-md shadow-lg image-fit zoom-in intro-x">
          {selectedLanguage === "en" ? (
            <US title="United States" className="mr-2 my-flag-style" />
          ) : (
            <FR title="France" className="mr-2 my-flag-style" />
          )}
          {selectedLanguage === "en" ? "English" : "Français"}
          <Lucide icon="ChevronDown" className="w-4 h-4 ml-2 my-auto mr-0" />
        </Menu.Button>
        <Menu.Items
          data-onboarding="profile-menu"
          className=" mt-px  relative bg-dark-6 before:block before:absolute before:bg-black before:inset-0 before:rounded-md before:z-[-1] text-white"
        >
          {/* <Menu.Header className="font-normal">
          <div className="font-medium">{`${profile?.firstName ? profile?.firstName : ""} ${profile?.lastName ? profile?.lastName : ""}`}</div>
          <div className="text-xs text-white/70 mt-0.5 dark:text-slate-500">
            {profile?.email}
          </div>
        </Menu.Header> */}
          {/* <Menu.Divider className="bg-white/[0.08]" /> */}
          {languages.map((el, index) => {
            return (
              <Link
                key={index}
                className="flex h-full w-full"
                href={redirectedPathName(el)}
              >
                <Menu.Item as="div" className="hover:bg-white/5 w-full">
                  {el === "en" ? (
                    <US title="United States" className="mr-2 my-flag-style" />
                  ) : (
                    <FR title="France" className="mr-2 my-flag-style" />
                  )}
                  {el === "en" ? "English" : "Français"}
                  <Lucide
                    icon="ChevronDown"
                    className="w-0 h-4 ml-2 my-auto mr-0 invisible"
                  />
                </Menu.Item>
              </Link>
            )
          })}

          {/* <Menu.Item className="hover:bg-white/5">
                  <Lucide icon="HelpCircle" className="w-4 h-4 mr-2" /> Help
                </Menu.Item> */}
          {/* <Menu.Divider className="bg-white/[0.08]" /> */}
          {/* <Menu.Item as="div" className="hover:bg-white/5 ">
          <button
            type="button"
            className="flex w-full h-full text-left"
            onClick={handleLogout}
          >
            <Lucide icon="ToggleRight" className="w-4 h-4 mr-2 my-auto" />
            {navigation.signout}
          </button>
        </Menu.Item> */}
        </Menu.Items>
      </Menu>
    </div>
  )
}
